import { TextSelection, type Transaction } from '@tiptap/pm/state';

import isEmptyParagraph from './isEmptyParagraph';

/** Where Enter leaves a block: the caret in the empty paragraph at `pos`, the one already there or a new one. */
const placeCaretBelow = (tr: Transaction, pos: number): Transaction => {
  const next = tr.doc.nodeAt(pos);
  if (!next || !isEmptyParagraph(next)) tr.insert(pos, tr.doc.type.schema.nodes.paragraph.create());
  return tr.setSelection(TextSelection.create(tr.doc, pos + 1)).scrollIntoView();
};

export default placeCaretBelow;
